"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultMessages = { "en": { "adp-react-components": { "calendar": { "MOVE_BACK": "navigate back", "MOVE_FORWARD": "navigate forward" }, "date-time-picker": { "SELECT_DATE": "Select Date", "SELECT_TIME": "Select Time" }, "dropdown-list": { "OPEN": "open dropdown", "FILTER_PLACEHOLDER": " ", "EMPTY_LIST": "There are no items in this list", "EMPTY_FILTER": "The filter returned no results" }, "list": { "EMPTY_LIST": "There are no items in this list" }, "masthead": { "SEARCH": "Search" }, "slide-in": { "BACK": "Back" }, "tabs": { "EMPTY_TABS": "There are no tabs" } } } }.en;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/localizers/default-messages.js
// module id = 460
// module chunks = 0 1 2 3 4 5 6